/**
 * 好友列表
 */
import React, {Component} from 'react';
import { ImageView, Gender, Grade , OfficialAuth} from '../../component/user-ui';
import lang from '../../lang';

class FriendListView extends Component {
	static defaultProps = {
		list: [],
		talkTo: function(){}
	}

	render() {
		return (
			<div className="friend-list hostlist-lite">
				<ul>
				{ 
					this.props.list.map((item, index)=>{
						return (
							<li key={index}>
								<FriendItemView data={item} talkTo={this.props.talkTo}/>
							</li>
						);	
					})
				}
				</ul>
				{ this.props.list.length == 0 ? <div className="mini-tip">{lang.template('互相关注即可成为好友哦~')}</div> : null}
			</div>
		);
	}
}

class FriendItemView extends Component {
	static defaultProps = {
		data: {},
		talkTo: function(){}
	}

	render() {
		let item = this.props.data;
		
		return (
			<div className="list-item" onClick={this.props.talkTo.bind(this, item)}>
                <div className="avatar">
                    <ImageView src={item.avatar} size={40} circle/>
                    { item.officialAuth > 0 ? <OfficialAuth value={item.officialAuth}/> : null }
                </div>
                <div className="refbox">
                    <div className="user">
                        <div className="username">{item.username}</div>
                        <Gender key="gender" value={item.gender}/>
                        <Grade key="grade" value={item.grade}/>
                    </div>
                </div>
            </div>
		);
	}
}

export default FriendListView;


// WEBPACK FOOTER //
// ./js/im/views/friend-list.js